
import { useEffect } from 'react';

interface TimerStateSyncProps {
  isActive: boolean;
  startTime: number | null;
  setStartTime: (value: number | null) => void;
}

export const useTimerStateSync = ({
  isActive,
  startTime,
  setStartTime
}: TimerStateSyncProps) => {
  // Synchronize isActive and startTime
  useEffect(() => {
    // If timer becomes active but doesn't have a startTime, set one
    if (isActive && !startTime) {
      console.log("[useTimerLogic] Setting startTime because timer is active but startTime is null");
      setStartTime(Date.now());
    }
    
    // If timer becomes inactive, clear the startTime
    if (!isActive && startTime) {
      console.log("[useTimerLogic] Clearing startTime because timer is inactive");
      setStartTime(null);
    }
  }, [isActive, startTime, setStartTime]);
};
